import NotificationAcceptedItem from "./NotificationAcceptedItem";
import NotificationRefusedItem from "./NotificationRefusedItem";
import NotificationProposalItem from "./NotificationProposalItem";
import NotificationRouteDeviationItem from "./NotificationRouteDeviationItem";
import NotificationAvoidAreaItem from "./NotificationAvoidAreaItem";
import NotificationInterestAreaItem from "./NotificationInterestAreaItem";
import NotificationRouteSuggestionItem from "./NotificationRouteSuggestionItem";
import NotificationPackagesReceivedQuestionItem from "./NotificationPackagesReceivedQuestionItem";
import NotificationPackagesNotReceivedReminderItem from "./NotificationPackagesNotReceivedReminderItem";
import NotificationPackagesDelayedDealerItem from "./NotificationPackagesDelayedDealerItem";
import NotificationAutoFinishedBySystem from "./NotificationAutoFinishedBySystem/NotificationAutoFinishedBySystem";

export const NotificationItem = {
    NotificationAcceptedItem,
    NotificationRefusedItem,
    NotificationProposalItem,
    NotificationRouteDeviationItem,
    NotificationAvoidAreaItem,
    NotificationInterestAreaItem,
    NotificationRouteSuggestionItem,
    NotificationPackagesReceivedQuestionItem,
    NotificationPackagesNotReceivedReminderItem,
    NotificationPackagesDelayedDealerItem,
    NotificationAutoFinishedBySystem,
}